import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdCheck, MdContentCopy, MdCopyAll, MdDownload, MdOutlineRule, MdPublic, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import Processo from '../Processo/Processo';
import Corretores from '../Corretores/Corretores';
import Fiscais from '../Fiscais/Fiscais';
import Alunos from '../Alunos/Alunos';
import ModalTermos from './ModalTermos';
import './label.css';
import CandidatosConflitos from '../CandidatosConflitos/CandidatosConflitos';
import RelatoriosGerais from '../RelatoriosGerais/RelatoriosGerais';
import Avaliadores from '../Avaliador/Avaliadores';
import Treinamentos from '../Treinamentos/TreinamentosInstituicao';
import FaculdadeConfiguracoes from "../FaculdadeConfiguracoes/FaculdadeConfiguracoes";
import '../Redacoes/label.css';
import '../Processo/label.css';
import './label.css';
import { Check } from '@material-ui/icons';
import { saveAs } from 'file-saver';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import TableEmptyState from '../ReusableComponents/TableEmptyState';

class ShowFaculdade extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      caminho: '',
      termos: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      faculdade: {},
      dashboard: {},
      loading_dashboard: true,
      loading_report: '',
      activeTab: -1,
      show_more: false,
      copy_api_key: false,
      copy_secret_key: false,
      total_processos: '-',
      candidate_geo_map: null,
      loading_candidate_geo_map: false
    };

  }

  candidateMapRef = React.createRef();

  componentDidUpdate(prevprops,prevState){
    if(prevState.activeTab!=-1 && this.state.activeTab==-1){
      this.props.history.push({ search: '' });
    }

    if (prevState.candidate_geo_map !== this.state.candidate_geo_map) {
      this.renderCandidateLeafletMap();
    }
  }

  get_dashboard(id) {
    this.setState({ loading_dashboard: true });

    fetch(`${URL}api/faculdade/dashboard/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();

        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }

        this.setState({
          dashboard: resp || {},
          loading_dashboard: false
        });
      } catch (err) {
        console.log(err);
        this.setState({ loading_dashboard: false });
      }
    }).catch((err) => {
      console.log(err);
      this.setState({ loading_dashboard: false });
    });
  }

  download_general_report(type) {
    this.setState({ loading_report: type });

    fetch(`${URL}api/faculdade/get_relatorio_geral/${this.state.faculdade.id}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();

        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }

        if (resp.path) {
          saveAs(resp.path, 'relatorio_' + type + '_' + moment().format('YYYY-MM-DD-HH:mm:ss') + '.csv');
        } else if (resp.result) {
          let csv = 'Nome;CPF;Número de Inscrição\n';
          resp.result.map((item) => {
            csv += `${item.name};${item.cpf};${item.numero_inscricao}\n`;
            return item;
          });

          var myblob = new Blob([csv], { type: 'text/plain' });
          saveAs(myblob, 'relatorio_' + type + '_' + moment().format('YYYY-MM-DD-HH:mm:ss') + '.csv');
        } else if (resp.message) {
          alert(resp.message);
        }
      } catch (err) {
        console.log(err);
      }

      this.setState({ loading_report: '' });
    }).catch((err) => {
      console.log(err);
      this.setState({ loading_report: '' });
    });
  }

  load_candidate_geo_map = (polling = false) => {
    if (this.state.loading_candidate_geo_map && !polling) return;

    this.setState({ loading_candidate_geo_map: true });

    fetch(`${URL}api/faculdade/get_relatorio_geral/${this.state.faculdade.id}/mapa_candidatos`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();

        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }

        if (resp.status === true && resp.map) {
          this.setState({ candidate_geo_map: resp.map, loading_candidate_geo_map: false });
          return;
        }

        if (resp.status === 'Pendente' || resp.status === 'Executando') {
          this.setState({ loading_candidate_geo_map: true });
          this.geoMapTimeout = setTimeout(() => this.load_candidate_geo_map(true), 15000);
          return;
        }

        if (resp.message) {
          alert(resp.message);
        }
      } catch (err) {
        console.log(err);
      }

      this.setState({ loading_candidate_geo_map: false });
    }).catch((err) => {
      console.log(err);
      this.setState({ loading_candidate_geo_map: false });
    });
  }

  renderCandidateLeafletMap() {
    const points = this.state.candidate_geo_map?.points || [];
    if (!this.candidateMapRef.current || points.length === 0) return;

    if (this.candidateLeafletMap) {
      this.candidateLeafletMap.remove();
    }

    this.candidateLeafletMap = L.map(this.candidateMapRef.current, {
      scrollWheelZoom: false,
      worldCopyJump: true
    }).setView([-14.235, -51.9253], 3);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(this.candidateLeafletMap);

    const bounds = [];
    points.forEach((point) => {
      const latitude = Number(point.latitude);
      const longitude = Number(point.longitude);
      const count = Number(point.count || 1);
      if (Number.isNaN(latitude) || Number.isNaN(longitude)) return;

      const radius = Math.max(45000, Math.min(450000, 45000 + count * 35000));
      L.circle([latitude, longitude], {
        color: '#ef4444',
        fillColor: '#ef4444',
        fillOpacity: Math.min(.35, .12 + count * .03),
        opacity: .28,
        radius
      }).addTo(this.candidateLeafletMap);

      L.circleMarker([latitude, longitude], {
        radius: Math.max(7, Math.min(18, 6 + count)),
        color: '#ffffff',
        fillColor: '#dc2626',
        fillOpacity: .95,
        weight: 2
      }).bindPopup(`
        <strong>${this.escapeMapText(point.city || '-')}, ${this.escapeMapText(point.region || '-')}, ${this.escapeMapText(point.country || '-')}</strong><br />
        ${count} ${this.context.t("label_candidates")}
      `).addTo(this.candidateLeafletMap);

      bounds.push([latitude, longitude]);
    });

    if (bounds.length > 0) {
      this.candidateLeafletMap.fitBounds(bounds, { padding: [30, 30], maxZoom: 6 });
    }

    setTimeout(() => {
      if (this.candidateLeafletMap) {
        this.candidateLeafletMap.invalidateSize();
      }
    }, 100);
  }

  escapeMapText(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  get_faculdade(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_faculdade/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, faculdade: resp.faculdade
          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }






  componentDidMount() {
    let tab = new URLSearchParams(this.props.location.search).get('tab');
    if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });else
    if (tab === null) this.setState({ activeTab: -1 });
    this.get_faculdade(this.props.match.params.id);
    this.get_dashboard(this.props.match.params.id);

    this.interval_dashboard = setInterval(() => {
      this.get_dashboard(this.props.match.params.id);
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval_dashboard);
    clearTimeout(this.geoMapTimeout);
    if (this.candidateLeafletMap) {
      this.candidateLeafletMap.remove();
    }
  }

  getTabIndex = (tabName) => {
    let index = 0;
    const tabs = [this.context.t("legacy_processos"),
    // 0
    'corretores', // 1
    'fiscais', // 2
    'avaliadores', // 3
    'candidatos' // 4
    ];

    index = tabs.length; // 5

    if (this.props.user?.empresa?.online_proccess == true) {
      if (tabName === 'relatorios') return index;
      index++;
    }

    if (this.props.user?.empresa?.plan?.training == true) {
      if (tabName === 'treinamentos') return index;
      index++;
    }

    if (tabName === 'configuracoes') return index;

    return index;
  };

  render() {
    const modules = [
    {
      id: 0,
      icon: "📋",
      title: this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("title_process") : this.context.t("legacy_vagas"),
      description: this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_gerencie_os_processos_seletivos") : this.context.t("legacy_gerencie_as_vagas_do_processo_seletivo")
    },
    {
      id: 1,
      icon: "👨‍🏫",
      title: this.context.t("graders"),
      description: this.context.t("legacy_gerencie_corretores")
    },
    {
      id: 2,
      icon: "🛡️",
      title: this.context.t("proctors"),
      description: this.context.t("legacy_gerencie_fiscais")
    },
    {
      id: 3,
      icon: "⭐",
      title: this.context.t("evaluators"),
      description: this.context.t("ui_gerencie_avaliadores_00986d21")
    },
    {
      id: 4,
      icon: "👥",
      title: this.context.t("candidates"),
      description: this.context.t("legacy_gerencie_candidatos")
    },
    ...(this.props.user?.empresa?.online_proccess ?
    [{
      id: this.getTabIndex("relatorios"),
      icon: "📊",
      title: this.context.t("legacy_relatorios"),
      description: this.context.t("legacy_visualize_indicadores")
    }] :
    []),

    ...(this.props.user?.empresa?.plan?.training ?
    [{
      id: this.getTabIndex("treinamentos"),
      icon: "🎓",
      title: this.context.t("trainings"),
      description: this.context.t("legacy_gerencie_treinamentos")
    }] :
    []),

    {
      id: this.getTabIndex("configuracoes"),
      icon: "⚙️",
      title: this.context.t("legacy_configuracoes"),
      description: this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_configuracoes_da_instituicao") : this.context.t("legacy_configuracoes_do_processo")
    }];

    if (this.state.loading_screen) return <SkeletonCoursePage />;
    const dashboard = this.state.dashboard || {};
    const dashboardProcesses = dashboard.processos || [];
    const relatoriosTab = this.getTabIndex("relatorios");
    const totalProcessos = this.state.total_processos || 0;
    const totalCandidatos = dashboard.alunos ?? this.state.total_candidatos ?? 0;
    const totalCorretores = dashboard.corretores ?? this.state.total_corretores ?? 0;
    const totalFiscais = dashboard.fiscais ?? this.state.total_fiscais ?? 0;
    const totalAvaliadores = dashboard.avaliadores?.length ?? this.state.total_avaliadores ?? 0;
    const totalCandidatosOnline = dashboard.alunos_online?.length ?? 0;
    const totalFiscaisOnline = dashboard.fiscais_online?.length ?? 0;
    const totalAvaliadoresOnline = dashboard.avaliadores?.length ?? 0;
    return (
      <div style={{ position: "relative" }}>
        <div className="process-breadcrumb">

          <Link to="/">
            {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("title_institution") : this.context.t("title_process")}
          </Link>

          <span>›</span>

          <strong>
            {this.state.faculdade.name}
          </strong>

        </div>

        <div className="institution-hero-card">

          <div className="institution-hero-left">

            <div
              className="institution-logo"
              style={{
                backgroundSize: 'contain',
                backgroundImage: `url(${this.state.faculdade.logo})`
              }} />


            <div className="institution-content">

              <h1>
                {this.state.faculdade.name}
              </h1>

              <p>{`
                ${this.context.t("legacy_gerencie")} `}{this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_os_processos") : this.context.t("legacy_as_vagas")}{`${this.context.t("legacy_candidatos_e_equipe")} `}{this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_da_instituicao") : this.context.t("legacy_do_processo")}.
              </p>

              <div className="institution-meta">

                <div className="meta-item">
                  📅
                  <span>{`
                    ${this.context.t("label_created_at_feminine")} `}{moment(this.state.faculdade.created_at).format("DD/MM/YYYY")}
                  </span>
                </div>

                <div className="meta-item">
                  👤
                  <span>{this.context.t("ui_responsavel_dac53a5e")}
                    {this.props.user.name}
                  </span>
                </div>

                {/* <div className="meta-item">
                      🏫
                      <span>
                        Instituição
                      </span>
                     </div> */}

              </div>

            </div>

          </div>

          <Link
            to="/"
            className="btn-back-modern">{this.context.t("ui_voltar_para_cd10d454")+' '}{this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("title_institution") : this.context.t("title_process")}
          </Link>

        </div>

       

       
        {this.state.activeTab == -1 && <>
        <div className="summary-container">

          <div className="summary-left">

            <h3>{`
              ${this.context.t("title_quick_summary")}
            `}</h3>

            <div className="summary-cards">

              <div className="summary-card">

                <div className="summary-icon blue">
                  📋
                </div>

                <div className="summary-number">
                  {totalProcessos}
                </div>

                <div className="summary-label">
                  {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("title_process") : this.context.t("legacy_vagas")}
                  
                </div>

              </div>

              <div className="summary-card">

                <div className="summary-icon green">
                  👥
                </div>

                <div className="summary-number">
                  {totalCandidatos}
                </div>

                <div className="summary-label">{`
                  ${this.context.t("candidates")}
                `}</div>

              </div>

              <div className="summary-card">

                <div className="summary-icon purple">
                  👨‍🏫
                </div>

                <div className="summary-number">
                  {totalCorretores}
                </div>

                <div className="summary-label">{`
                  ${this.context.t("graders")}
                `}</div>

              </div>

              <div className="summary-card">

                <div className="summary-icon orange">
                  🛡️
                </div>

                <div className="summary-number">
                  {totalFiscais}
                </div>

                <div className="summary-label">{`
                  ${this.context.t("proctors")}
                `}</div>

              </div>

              <div className="summary-card">

                <div className="summary-icon purple">
                  ⭐
                </div>

                <div className="summary-number">
                  {totalAvaliadores}
                </div>

                <div className="summary-label">{`
                  ${this.context.t("evaluators")}
                `}</div>

              </div>

            </div>

          </div>

          <div className="summary-right">

            <h3>{`
              ${this.context.t("legacy_informacoes")}
            `}</h3>

            <div className="activity-list">

              <div className="activity-item">
                <div className="activity-dot"></div>

                <span>{`
                  ${this.context.t("legacy_api_integrada_e_ativa")}
                `}</span>
              </div>

              <div className="activity-item">
                <div className="activity-dot"></div>

                <span>
                  {this.state.faculdade.termos ? this.context.t("legacy_termos_cadastrados") : this.context.t("legacy_termos_nao_cadastrados")

                    }
                </span>
              </div>

              <div className="activity-item">
                <div className="activity-dot"></div>

                <span>{this.context.t("ui_instituicao_criada_em_8e333c6a")}
                    {" "}
                  {moment(this.state.faculdade.created_at).
                    format("DD/MM/YYYY")}
                </span>
              </div>

            </div>

          </div>

        </div>

        <div className="institution-dashboard-section">

          <div className="dashboard-panel">

            <div className="dashboard-panel-header">
              <div>
                <h3>{this.context.t("title_realtime_indicators")}</h3>
                <p>{this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("desc_institution_dashboard_data") : this.context.t("desc_process_dashboard_data")}</p>
              </div>

              {this.state.loading_dashboard && <CircularProgress size={22} />}
            </div>

            <div className="live-metrics-grid">
              <div className="live-metric-card">
                <span>{this.context.t("legacy_candidatos_online")}</span>
                <strong>{totalCandidatosOnline}</strong>
              </div>

              <div className="live-metric-card">
                <span>{this.context.t("legacy_fiscais_online")}</span>
                <strong>{totalFiscaisOnline}</strong>
              </div>

              <div className="live-metric-card">
                <span>{this.context.t("legacy_avaliadores_online")}</span>
                <strong>{totalAvaliadoresOnline}</strong>
              </div>
            </div>

          </div>

          {this.props.user?.empresa?.online_proccess == true &&
            <div className="dashboard-panel">

              <div className="dashboard-panel-header">
                <div>
                  <h3>{this.context.t("title_quick_reports")}</h3>
                  <p>{this.context.t("legacy_baixe_relatorios_gerais_ou_abra_a_area_completa_de_relatorios")}</p>
                </div>
              </div>

              <div className="report-actions-grid">
                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => this.download_general_report('login')}
                  disabled={this.state.loading_report !== ''}>

                  <span className="report-action-icon"><MdDownload /></span>
                  <strong>{this.context.t("legacy_quem_ja_fez_login")}</strong>
                  <small>{this.state.loading_report === 'login' ? this.context.t("action_generating_csv") : this.context.t("action_download_csv")}</small>
                </button>

                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => this.download_general_report('tela_avaliacao_nao_iniciada')}
                  disabled={this.state.loading_report !== ''}>

                  <span className="report-action-icon"><MdDownload /></span>
                  <strong>{this.context.t("legacy_permissoes_concedidas")}</strong>
                  <small>{this.state.loading_report === 'tela_avaliacao_nao_iniciada' ? this.context.t("action_generating_csv") : this.context.t("action_download_csv")}</small>
                </button>

                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => this.download_general_report('resultados_provas')}
                  disabled={this.state.loading_report !== ''}>

                  <span className="report-action-icon"><MdDownload /></span>
                  <strong>{this.context.t("report_exam_results_by_institution")}</strong>
                  <small>{this.state.loading_report === 'resultados_provas' ? this.context.t("action_generating_csv") : this.context.t("action_download_csv")}</small>
                </button>

                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => this.download_general_report('candidatos_geral')}
                  disabled={this.state.loading_report !== ''}>

                  <span className="report-action-icon"><MdDownload /></span>
                  <strong>{this.context.t("report_all_candidates_general")}</strong>
                  <small>{this.state.loading_report === 'candidatos_geral' ? this.context.t("action_generating_csv") : this.context.t("action_download_csv")}</small>
                </button>

                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => this.load_candidate_geo_map()}
                  disabled={this.state.loading_candidate_geo_map}>

                  <span className="report-action-icon"><MdPublic /></span>
                  <strong>{this.context.t("report_candidates_world_map")}</strong>
                  <small>{this.state.loading_candidate_geo_map ? this.context.t("action_generating_map") : this.context.t("action_view_map")}</small>
                </button>

                <button
                  type="button"
                  className="report-action-card"
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    this.setState({ activeTab: relatoriosTab });
                    this.props.history.push({ search: `?tab=${relatoriosTab}` });
                  }}>

                  <span className="report-action-icon">📊</span>
                  <strong>{this.context.t("legacy_todos_os_relatorios")}</strong>
                  <small>{this.context.t("legacy_abrir_modulo")}</small>
                </button>

              </div>

              {this.state.candidate_geo_map != null &&
                <div className="candidate-map-section">
                  <div className="candidate-map-header">
                    <div>
                      <h4>{this.context.t("title_candidates_geolocation_map")}</h4>
                      <p>{this.context.t("desc_candidates_geolocation_map")}</p>
                    </div>
                    <span>{(this.state.candidate_geo_map.points || []).reduce((total, point) => total + Number(point.count || 0), 0)} {this.context.t("label_candidates")}</span>
                  </div>

                  {(this.state.candidate_geo_map.points || []).length > 0 ?
                    <div className="candidate-world-map" ref={this.candidateMapRef} /> :
                    <div className="candidate-map-empty">{this.context.t("empty_no_geolocation_found")}</div>
                  }
                </div>
              }

            </div>
            }

        </div>

        </>}


        <div className="modules-container">

          <h5 className="section-title">{`
            ${this.context.t("title_choose_module_manage")}
          `}</h5>

          <div className="modules-grid">

            {modules.map((module) =>

              <div
                key={module.id}
                className={`module-card ${this.state.activeTab === module.id ?
                'active' :
                ''}`
                }
                onClick={() => {
                  // window.scrollTo({ top: 0, behavior: 'smooth' });
                  this.setState({
                    activeTab: module.id
                  });
                  this.props.history.push({
                    search: `?tab=${module.id}`
                  });
                }
                }>


                <div className="module-icon">

                  {module.icon}

                </div>

                <div>

                  <h6
                    style={{
                      fontWeight: 600,
                      marginBottom: 6
                    }}>

                    {module.title}
                  </h6>

                  <p>
                    {module.description}
                  </p>

                </div>

              </div>

              )}

          </div>

        </div>

         {this.state.activeTab == -1 && this.props.user?.empresa?.online_proccess == true &&
        <>
            <div className="process-info-grid">

              <div className="process-info-card clickable" onClick={() => {
              this.setState({ copy_api_key: true });

              navigator.clipboard.writeText(
                this.state.faculdade.apikey
              );
            }}>
                <div className="icon blue">{this.state.copy_api_key ? <Check style={{ color: 'green' }} color='green' /> : '🔑'}</div>

                <div>
                  <span>API Key</span>
                  <strong>{this.state.faculdade.apikey}</strong>
                </div>
              </div>

              <div className="process-info-card clickable" onClick={() => {
              navigator.clipboard.writeText(
                this.state.faculdade.apisecret
              );
              this.setState({ copy_secret_key: true });
            }}>
                <div className="icon purple">{this.state.copy_secret_key ? <Check style={{ color: 'green' }} /> : '🔒'}</div>

                <div>
                  <span>API Secret</span>
                  <strong>{this.state.faculdade.apisecret}</strong>
                </div>
              </div>

              <div
              className="process-info-card clickable"
              onClick={() => this.setState({ show_more: true })}>

                <div className="icon green">
                  <MdOutlineRule />
                </div>

                <div>
                  <span>{this.context.t("label_terms")}</span>
                  <strong>{this.context.t("action_view_terms")}</strong>
                </div>
              </div>

            </div>
            <ModalTermos
            showModal={this.state.show_more}
            setShowModal={(e) => this.setState({ show_more: e })}
            processo_name={this.state.faculdade.name}
            termos={this.state.faculdade.termos} />

          </>
        }


        <TabPanel value={this.state.activeTab} padding={0} index={0}>
          <Processo
            setState={(data) => this.setState(data)}
            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug}
            setState={(e) => this.setState({ total_processos: e })} 
            setStateTab={(e) => this.setState(e)} 
            
            />

        </TabPanel>
        <TabPanel value={this.state.activeTab} padding={0} index={1}>
          <Corretores
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

        </TabPanel>
        <TabPanel value={this.state.activeTab} padding={0} index={2}>
          {/* <AddToCourse/> */}
          {this.props.user?.empresa?.online_proccess == true &&
          <Fiscais
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

          }
          {this.props.user?.empresa?.online_proccess == false &&
          <TableEmptyState title={this.context.t("ui_modulo_nao_habilitado_f5792cfe")} icon="📋" />
          }
        </TabPanel>
        <TabPanel value={this.state.activeTab} padding={0} index={3}>
          {/* <AddToCourse/> */}
          {this.props.user?.empresa?.online_proccess == true &&
          <Avaliadores
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

          }
          {this.props.user?.empresa?.online_proccess == false &&
          <TableEmptyState title={this.context.t("ui_modulo_nao_habilitado_f5792cfe")} icon="📋" />
          }
        </TabPanel>
        <TabPanel value={this.state.activeTab} padding={0} index={4}>
          <Alunos
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

        </TabPanel>
        {this.props.user?.empresa?.online_proccess == true &&
        <TabPanel
          padding={0}
          value={this.state.activeTab}
          index={5}>

            <RelatoriosGerais
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

          </TabPanel>
        }

        {this.props.user?.empresa?.plan?.training == true &&
        <TabPanel
          padding={0}
          value={this.state.activeTab}
          index={6}>

            <Treinamentos
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} />

          </TabPanel>
        }

        {<TabPanel
          padding={0}
          value={this.state.activeTab}
          index={7}>

          {this.props.user?.empresa?.plan?.training == true ? <FaculdadeConfiguracoes
            setState={(data) => this.setState(data)}

            faculdade_id={this.state.faculdade.id}
            faculdade_name={this.state.faculdade.name}
            slug={this.state.faculdade.slug} /> :
          <p style={{ textAlign: "center" }}>{this.context.t("ui_modulo_nao_habilitado_f5792cfe")}

          </p>}
        </TabPanel>}

        {/* <TabPanel value={this.state.activeTab} index={4}>
                                <CandidatosConflitos faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} slug={this.state.faculdade.slug}/>
                             </TabPanel> */
        }
      </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token,
  user: state.AppReducer.user

});


const SkeletonCoursePage = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="skeleton-title" />
        {/* <div className="skeleton-small-text skeleton-shimmer"/>
                    <div className="skeleton-small-text skeleton-shimmer"/> */}
        <br />
        <div className="w100 flex jcc align-center">
          <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
        </div>
        <br />
        <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
        <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
        <div className="skeleton-small-button skeleton-shimmer" />
      </div>
    </div>);

};

export default connect(mapsStateToProps, { logout })(ShowFaculdade);
